import script from "./StaffList.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffList.vue?vue&type=script&setup=true&lang=js"

import "./StaffList.vue?vue&type=style&index=0&id=1cf8588c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cf8588c"]])

export default __exports__